import React, { useState } from "react";
import { toast } from "sonner";
import { BadgeCheck, Check, Loader2, X, Sparkles } from "lucide-react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const perks = [
  "Glowing verified badge next to your name",
  "Priority placement in search & suggestions",
  "Stand out in comments and chats",
  "Support the Xealth community",
];

export default function VerifiedModal({ open, onClose }) {
  const [busy, setBusy] = useState(false);

  const subscribe = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", { origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not start checkout");
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent data-testid="verify-modal" className="bg-card border-2 border-[#6C0BA9] rounded-3xl p-0 overflow-hidden max-w-md">
        <DialogTitle className="sr-only">Get Verified</DialogTitle>
        <div className="relative px-6 pt-8 pb-6 text-center bg-gradient-to-b from-[#6C0BA9]/30 to-transparent">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-40 h-40 rounded-full bg-[#6C0BA9] opacity-30 blur-3xl" />
          <div className="relative mx-auto w-16 h-16 rounded-2xl bg-gradient-to-br from-[#6C0BA9] to-[#C084FC] flex items-center justify-center shadow-lg shadow-[#6C0BA9]/50 x-pulse mb-4">
            <BadgeCheck className="w-9 h-9 text-white" />
          </div>
          <h2 className="font-heading text-2xl font-extrabold">Get Verified</h2>
          <p className="text-sm text-muted-foreground mt-1">Unlock your glowing badge and stand out.</p>
          <div className="mt-4 flex items-baseline justify-center gap-1">
            <span className="font-heading text-5xl font-extrabold bg-gradient-to-r from-[#C084FC] to-[#E024A3] bg-clip-text text-transparent">$4</span>
            <span className="text-muted-foreground text-sm">/ month</span>
          </div>
        </div>

        <div className="px-6 pb-6 space-y-3">
          {perks.map((p) => (
            <div key={p} className="flex items-center gap-3 text-sm">
              <span className="w-5 h-5 rounded-full bg-[#6C0BA9]/20 flex items-center justify-center shrink-0">
                <Check className="w-3.5 h-3.5 text-[#C084FC]" />
              </span>
              {p}
            </div>
          ))}
          <Button data-testid="verify-subscribe-btn" onClick={subscribe} disabled={busy} className="w-full h-12 mt-2 rounded-xl bg-[#6C0BA9] hover:bg-[#8012C6] text-white font-semibold text-base shadow-lg shadow-[#6C0BA9]/40 gap-2">
            {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <><Sparkles className="w-5 h-5" />Subscribe & Get Verified</>}
          </Button>
          <p className="text-center text-xs text-muted-foreground">Secure checkout via Stripe. Cancel anytime.</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
